import { motion, useScroll, useSpring } from "framer-motion";
import { usePrefersReducedMotion } from "@/hooks/usePrefersReducedMotion";
import "../../styles/interactive.css";

/** Thin accent bar pinned to the top of the viewport that fills as the page scrolls. */
export default function ScrollProgress() {
    const { scrollYProgress } = useScroll();
    const smoothed = useSpring(scrollYProgress, { stiffness: 140, damping: 28, restDelta: 0.001 });
    const reducedMotion = usePrefersReducedMotion();
    return <motion.div className="scroll-progress" style={{ scaleX: reducedMotion ? scrollYProgress : smoothed }} aria-hidden="true" />;
}
